import { FolderOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { LayoutDashboardIcon } from 'lucide-react';

import {
  NAVIGATOR_TARGET,
  type NavigatorSelectItem,
} from '@/features/Commons/NavigatorFloat/types/navigatorTypes';
import service from '@/services';

const useFlattenDashboardListQuery = () => {
  const fetcher = async () => {
    const result: NavigatorSelectItem[] = [];
    const d = await service.dashboard2.fetchDashboardTreeList();
    const promises = d.dashboard_folders?.map((folder) => {
      return service.dashboard2.fetchDashboardsInFolder(folder.alias);
    });
    const dashboardsInFolders = await Promise.all(promises || []);

    d.dashboards?.forEach((dashboard) => {
      result.push({
        target: NAVIGATOR_TARGET.DASHBOARD,
        alias: dashboard.alias,
        name: dashboard.title,
        icon: <LayoutDashboardIcon width={20} height={20} />,
        href: `/dashboard2/${dashboard.alias}`,
      });
    });

    d.dashboard_folders?.forEach((folder) => {
      result.push({
        target: NAVIGATOR_TARGET.DASHBOARD_FOLDER,
        alias: folder.alias,
        name: folder.name,
        icon: <FolderOutlined style={{ fontSize: 20 }} />,
        href: `/dashboard2/list/folder/${folder.alias}`,
      });
    });

    dashboardsInFolders.forEach((res) => {
      res.dashboards?.forEach((dashboard) => {
        result.push({
          target: NAVIGATOR_TARGET.DASHBOARD,
          alias: dashboard.alias,
          name: dashboard.title,
          icon: <LayoutDashboardIcon width={20} height={20} />,
          path: d.dashboard_folders?.find(
            (folder) => folder.alias === dashboard.folder_id,
          )?.name,
          href: `/dashboard2/${dashboard.alias}`,
        });
      });
    });

    return result;
  };
  return useQuery({
    queryKey: ['flatten-dashboard-list'],
    queryFn: fetcher,
    staleTime: 1000 * 60 * 5,
  });
};

export default useFlattenDashboardListQuery;
